<script setup>
const props = defineProps({
  item: Object,
  recipeId: {
    type: Number,
    default: 0,
  },
  position: {
    type: Number,
    default: 0,
  },
})
const userStore = useUserStore()
const config = useRuntimeConfig()
const modalStore = useModalStore()

// Conditions
const hasCoupon = computed(() =>
  props.item.item_label.includes('coupon')
  || props.item.item_description.includes('coupon')
  || props.item.price_description.includes('coupon'),
)

const hasMembre = computed(() =>
  props.item.item_label.includes('membre')
  || props.item.item_description.includes('membre')
  || props.item.price_description.includes('membre'),
)
</script>

<template>
  <li>
    <div class="block hover:bg-poivre-50">
      <div class="px-2 py-2">
        <div class="flex items-center space-x-3">
          <div class="flex-shrink-0 block cursor-pointer" @click.prevent="modalStore.openItemModal(item.id)">
            <img class="h-12 w-12" :src="item.cdn_thumbnail_url" alt="">
          </div>
          <div class="flex-1 min-w-0 cursor-pointer" @click.prevent="modalStore.openItemModal(item.id)">
            <p class="text-sm/4 font-normal  line-clamp-2 lg:truncate">
              <span class="text-poivre-700">{{ item.item_label }}</span> <span class="text-poivre-400">{{ item.item_description }}</span>
            </p>
            <div class="flex flex-wrap items-center gap-x-2 gap-y-1">
              <div class="min-w-0 text-poivre-500 font-bold break-words text-sm">
                {{ item.price_text }}
              </div>

              <div class="flex shrink-0 items-center gap-x-2">
                <div class="inline-flex h-4 items-center text-xs font-normal text-white">
                  <img class="h-full" :src="`${config.public.backendCdnUrl}/u/stores/${item.store_slug}.png`" alt="">
                </div>

                <div
                  v-if="item.ing_score !== 0"
                  class="grid h-6 w-6 shrink-0 cursor-pointer place-items-center rounded-full text-center text-sm font-medium text-white opacity-90"
                  :style="`background-color:${item.colors.star_color};color:white`"
                >
                  {{ item.ing_score }}
                </div>
              </div>
            </div>
          </div>

          <div class="flex space-x-2">
            <ShoppingListMiniButton :flyer-item="item" />
          </div>
        </div>
      </div>
    </div>
  </li>

  <div
    v-if="(position === 5 || position === 11 || position === 17) && (!userStore.user || userStore.user.extra === 0)"
    class="hidden items-center bg-white overflow-hidden py-2"
  >
    <Ad class="max-h-100 overflow-hidden w-full" format="square" />
  </div>
</template>
